import { createSlice } from '@reduxjs/toolkit';
import { ApiStatus } from '../../utils/api.types';
import { fetchChargeLedgers, fetchLedger, ILedger } from './ledgerThunk';

export interface LedgerState {
    ledgers: ILedger[];
    chargeLedgers: ILedger[];
    expenseLedgers: ILedger[];
    status: ApiStatus;
    error: string | null;
}

const initialState: LedgerState = {
    ledgers: [],
    chargeLedgers: [],
    expenseLedgers: [],
    status: ApiStatus.IDLE,
    error: null
};

const ledgerSlice = createSlice({
    name: 'ledger',
    initialState,
    reducers: {
        clearLedgers: (state) => {
            state.ledgers = [];
            state.chargeLedgers = [];
            state.expenseLedgers = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch All Ledgers
            .addCase(fetchLedger.pending, (state) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchLedger.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.ledgers = action.payload;
            })
            .addCase(fetchLedger.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.error = action.error.message || 'Failed to fetch ledgers';
            })
            // Fetch Charge Ledgers
            .addCase(fetchChargeLedgers.pending, (state) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchChargeLedgers.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                // Store in appropriate array based on meta.arg (income/expense)
                if (action.meta.arg === 'expense') {
                    state.expenseLedgers = action.payload;
                } else {
                    state.chargeLedgers = action.payload;
                }
            })
            .addCase(fetchChargeLedgers.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.error = action.error.message || 'Failed to fetch charge ledgers';
            });
    }
});

export const { clearLedgers } = ledgerSlice.actions;
export default ledgerSlice.reducer;
